import React from 'react';

const AccessibilityHidden = ({ children }) => {

  return React.Children.map(children, (child) => {
    if (typeof child === 'string') {
      // Wrap string children with a span and add aria-hidden
      return <span aria-hidden="true">{child}</span>;
    } else if (React.isValidElement(child)) {
      // Add aria-hidden to valid React elements
      return React.cloneElement(child, {
        'aria-hidden': true,
      });
    }
    return child;
  });
};

export default AccessibilityHidden;
